function installVueGlobal(Vue, globalName, globalValue) {
  const globalPrototype = Vue.version.slice(0, 2) === '3.' ? Vue.config.globalProperties : Vue.prototype;

  // Don't use Object.assign() to match the Vue.js supported browsers (ECMAScript 5)
  globalPrototype[globalName] = globalValue;
}

const viewUtils = {
  showSpinner(entities) {
    let table = document.getElementById('genericTable')
    table.classList.add('loading')
    if (entities.length <= 2 ) {
      table.style.setProperty('--size', '40px 40px');
    } else {
      table.style.setProperty('--size', '70px 70px');
    }
  },
  hideSpinner() {
    let table = document.getElementById('genericTable')
    table.classList.remove('loading')
  },
}

// eslint-disable-next-line no-unused-vars
export default function install(Vue, locale="es", options={}) {

  installVueGlobal(Vue, '$viewUtils', viewUtils);
}